import ChangePassword from '../component/lining/modal/ChangePassword';

const customizedModal = require(`./${process.env.BRANCH_ENV}/customized.modal`).default;

export default {
  ...customizedModal,
  ChangePassword: {
    component: ChangePassword
  }
};
